// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createActions, handleActions } from 'redux-actions';

export const {
    getUserInfoData,
    getUserInfoDataFail,
    getUserInfoDataRequest,
    getUserInfoDataSuccess,
    setUserTierData,
    setUserTierDataFail,
    setUserTierDataRequest,
    setUserTierDataSuccess,
    setSelectedOptionData,
} = createActions(
    'GET_USER_INFO_DATA',
    'GET_USER_INFO_DATA_FAIL',
    'GET_USER_INFO_DATA_REQUEST',
    'GET_USER_INFO_DATA_SUCCESS',
    'SET_USER_TIER_DATA',
    'SET_USER_TIER_DATA_FAIL',
    'SET_USER_TIER_DATA_REQUEST',
    'SET_USER_TIER_DATA_SUCCESS',
    'SET_SELECTED_OPTION_DATA'
);
export interface UserInfoType {
    channelId: number;
    channelTierId: number;
    comments: string;
    domainAlias: string;
    email: string;
    firstName: string;
    isActive: boolean;
    isWarrantyUpdateEnabled: boolean;
    lastLoggedInDateTime: Date;
    lastModifiedBy: number;
    lastModifiedDate: Date;
    lastName: string;
    phone: string;
    puid: string;
    retailUserId: number;
    roleName: string;
    shiptoCustomerNbr: string;
    soldToCustomerNbr: string;
    tierId: number;
    tierName: string;
    createdDate: Date;

    shiptoCustomerName: string;
    soldtoCustomerName: string;
    addressLineOneText: string;
    addressLineTwoText: string;
    addressLineThreeText: string;
    cityName: string;
    postalCode: string;
    stateProvinceCode: string;
    countryCode: string;
    countryName: string;
}

export const INITIAL_STATE: {
    isValid: boolean;
    loading: boolean;
    userInfo: UserInfoType | {};
    selectedOption: String;
} = { isValid: false, loading: true, userInfo: {}, selectedOption: '' };

export type UserInfoStoreType = Readonly<typeof INITIAL_STATE>;

export default handleActions(
    {
        [getUserInfoDataFail.toString()]: _getUserInfoFailed,
        [getUserInfoDataRequest.toString()]: _getUserInfoDataRequest,
        [getUserInfoDataSuccess.toString()]: _getUserInfo,
        [setUserTierDataFail.toString()]: _setUserTierFailed,
        [setUserTierDataRequest.toString()]: _setUserTierDataRequest,
        [setUserTierDataSuccess.toString()]: _setUserTier,
        [setSelectedOptionData.toString()]: _setSelectedOption,
    },
    INITIAL_STATE
);

function _getUserInfo(
    state: any,
    { payload }: { payload: UserInfoType }
): UserInfoStoreType {
    if (payload) {
        return {
            ...state,
            isValid: true,
            loading: false,
            userInfo: payload,
        };
    }

    return state;
}

function _getUserInfoFailed(state: any) {
    return {
        ...state,
        isValid: false,
        loading: false,
        userInfo: {},
        selectedOption: '',
    };
}

function _getUserInfoDataRequest(state: any) {
    return {
        ...state,
        isValid: false,
        loading: true,
        userInfo: {},
        selectedOption: '',
    };
}

function _setUserTier(
    state: any,
    { payload }: { payload: any }
): UserInfoStoreType {
    if (payload) {
        return {
            ...state,
            userInfo: { ...state.userInfo, ...payload.userInfo },
        };
    }

    return state;
}

function _setUserTierFailed(state: any) {
    return {
        ...state,
        isValid: false,
        loading: false,
        userInfo: {},
        selectedOption:'',
    };
}

function _setUserTierDataRequest(state: any) {
    return {
        ...state,
        loading: true,
    };
}

function _setSelectedOption(
    state: any,
    { payload }: { payload: any }
): UserInfoStoreType {
    if (payload) {
        return {
            ...state,
            selectedOption: payload,
        };
    }

    return state;
}